<script>
import "./style.scss";
import TableTemp from "../tableTemp/index.vue";
let createEl, self;

const buttons = [
  { id: "product", label: "商品信息" },
  { id: "user", label: "用户详情" },
  { id: "order", label: "订单基础信息" },
  { id: "by_stages", label: "分期详情" },
  { id: "repayment", label: "订单还款信息" }
  // { id: "model", label: "基本信息" }
];
// 商品信息
const productList = [
  { id: "product_name", label: "商品名称" },
  { id: "product_attr", label: "商品规格" },
  { id: "jindun_num", label: "设备号" },
  { id: "username", label: "购买人真实姓名" },
  { id: "total_price", label: "商品总金额" },
  { id: "total_pay_price", label: "实际付款金额" },
  { id: "delivery_type_status", label: "配送方式" },
  { id: "express_no", label: "物流单号" },
  { id: "delivery_time", label: "发货时间" },
  { id: "express_company", label: "物流公司" }
];
// 用户详情
const userList = [
  { id: "username", label: "姓名" },
  { id: "gender", label: "性别" },
  { id: "birthday", label: "生日" },
  { id: "usernum", label: "身份证号" },
  { id: "mobile", label: "手机号" }
  // { id: "occupation", label: "职业" },
  // { id: "mobile", label: "芝麻收货手机号" },
  // { id: "ocrAddress", label: "户籍地址" },
  // { id: "address_id", label: "最近联系地址" },
  // { id: "address_id", label: "订单配送地址" }
];
// 订单基础信息
const orderList = [
  { id: "order_no", label: "订单号" },
  { id: "order_status", label: "订单状态" },
  { id: "order_source", label: "订单来源" },
  { id: "repayment_date", label: "还款时间" },
  { id: "total_price", label: "累计租金" },
  { id: "Total_number_of_periods", label: "累计期数" },
  { id: "create_time", label: "订单申请时间" },
  { id: "total_num", label: "数量" },
  { id: "transaction_id", label: "支付宝订单号" },
  { id: "deposit", label: "商品押金" },
  // { id: "deposit", label: "支付宝免押额度" },
  // { id: "deposit", label: "支付宝已冻结押金" },
  // { id: "zhuanzujin", label: "押金转支付金额" },
  { id: "total_price", label: "签约价值" },
  { id: "pay_type", label: "支付方式" },
  // { id: "proportion_of_agents", label: "分销员租金抽佣比例" },
  { id: "delivery_type_status", label: "提货方式" }
];
// 分期详情
const orderBill_1 = [
  { id: "current_period", label: "期数" },
  { id: "repayment_date", label: "还款日" },
  { id: "price", label: "应还租金" },
  { id: "jieqin", label: "结清状态" },
  { id: "yuqi", label: "逾期天数" }
];
// 订单还款明细
const orderBill_2 = [
  { id: "bill_id", label: "序号" },
  { id: "pay_type", label: "交易类型" },
  { id: "username", label: "交易发起人" },
  { id: "price", label: "支付金额" },
  { id: "paytime", label: "交易发起时间" }
];
//基本信息
// const modelList = [
//   { id: "model_name", label: "模型名称" },
//   { id: "model_type", label: "模型类型" },
//   { id: "model_status", label: "模型状态" },
//   { id: "model_desc", label: "模型描述" },
//   { id: "model_create_time", label: "模型创建时间" },
//   { id: "model_update_time", label: "模型更新时间" }

// 逾期信息
const beOverdueList = [
  { id: "order_no", label: "订单号" },
  { id: "yuqi", label: "逾期天数" },
  { id: "price", label: "应还总额" },
  // { id: "model_desc", label: "应还滞纳金" },
  { id: "remain_deposit", label: "订单剩余押金金额" },
  // { id: "model_update_time", label: "已还滞纳金" },
  { id: "model_update_time---", label: "已还租金" }
];
// 联系人信息
const contactsList = [
  { id: "jjrealname", label: "真实姓名" },
  { id: "contactName", label: "姓名" },
  { id: "contactPhone", label: "联系方式" },
  { id: "relation", label: "关系" }
];
// ];
const temp = {
  title: "逾期信息",
  icon: "dhx__icon_overdue",
  data: []
};

const temp1 = {
  title: "联系人信息",
  icon: "dhx__icon_overdue",
  data: []
};

const baseData = {
  activeItem: 0,
  dataList: {},
  listVal: [],
  beOverdueVal: [],
  contactVal:[]
};

const funcs = {};

const detailOptionItem = {
  props: {
    label: String,
    value: String
  },
  render(createEl) {
    return createEl("span", this.label + ": " + this.value);
  }
};
function convertToKeyValueArr(obj, arr) {
  const result = [];
  console.log(obj,arr);
  arr.forEach(item => {
    // const objKey = item.id.replace(/ /g, "_").toLowerCase();
    const objKey = item.id
    if (obj.hasOwnProperty(objKey)) {
      result.push({
        label: item.label,
        value: obj[objKey]
      });
    } else {
      result.push({
        label: item.label,
        value: null
      });
    }
  });
  return result;
}
function convertToKeyValueArray(obj, productName) {
  console.log(obj, productName, "obj");
  // const result = [];
  let result;
  if (productName == "product") {
    // productList.forEach(item => {
    //   const objKey = item.id.replace(/ /g, "_").toLowerCase();
    //   if (obj.hasOwnProperty(objKey)) {
    //     result.push({
    //       label: item.label,
    //       value: obj[objKey]
    //     });
    //   } else {
    //     result.push({
    //       label: item.label,
    //       value: null
    //     });
    //   }
    // });
    result = convertToKeyValueArr(obj, productList);
  } else if (productName == "user") {
    result = convertToKeyValueArr(obj, userList);
  } else if (productName == "order") {
    result = convertToKeyValueArr(obj, orderList);
  } else if (productName == "by_stages") {
    result = convertToKeyValueArr(obj, orderBill_1);
  } else if (productName == "repayment") {
    result = convertToKeyValueArr(obj, orderBill_2);
  } else if (productName == "beOverdue") {
    result = convertToKeyValueArr(obj, beOverdueList);
  }else if(productName == 'contact'){
    result = convertToKeyValueArr(obj, contactsList);
  }
  // } else {
  //   Object.keys(obj).forEach(key => {
  //     result.push({
  //       label: key,
  //       value: obj[key]
  //     });
  //   });
  // }
  return result;
}
funcs.clickBtn = (item, key, list) => {
  // console.log(item, key, list[item]);
  self.listVal = convertToKeyValueArray(list, item);
  self.activeItem = key;
};

function createNav(self, activeItem) {
  return buttons.map((item, index) =>
    createEl(
      "el-button",
      {
        class: `dhx__nav-btn ${activeItem === index ? "active_btn" : ""}`,
        props: {
          type: activeItem === index ? "primary" : "ordinary",
          size: "mini"
        },
        on: { click: () => self.clickBtn(item.id, index, self.dataList) }
      },
      item.label
    )
  );
}

function handlerInfo(res) {
  const { title, icon, data } = res;
  return createEl(
    "div",
    {
      class: "full"
    },
    [
      createEl(
        "div",
        {
          class: "dhx__info-title d-s-c d-r"
        },
        [
          createEl("i", { class: icon }, []),
          createEl("span", { class: "ml5" }, title)
        ]
      )
    ]
  );
}

const valueStyle = {
  backgroundColor: "#fff"
};
const formatList = function(list) {
  let row = [];
  let result = [];

  if (Object.prototype.toString.call === "[object Array]") return [];

  list.forEach((item, index) => {
    if (index % 2 == 0) row = [];
    else result.push(row);
    item.attrs = {};
    row.push(item);
  });

  // console.log(result);
  return result;
};
function createTable(create) {
  // console.log(create,'create');
  // return createEl(TableTemp, {}, []);
  if (!create) return;
  return createEl(
    "table",
    {
      class: "dhx__table-temp"
    },
    [
      formatList(create).map(row =>
        createEl(
          "tr",
          {
            class: "dhx__table-temp-row"
          },
          row
            .map(item => [
              createEl("td", {}, item.label),
              createEl("td", { style: valueStyle }, item.value)
            ])
            .flat()
        )
      )
    ]
  );
}

const render = function(create) {
  createEl = create;
  self = this;
  // console.log(self.activeItem, "self.activeItem");
  return createEl(
    "div",
    {
      class: "dhx__container"
    },
    [
      createEl(
        "nav",
        {
          class: "dhx__nav d-s-c d-r mt10"
        },
        createNav(this, this.activeItem)
      ),
      createEl(
        "div",
        {
          class: "dhx__content d-c-s d-c"
        },
        [
          createEl(
            "div",
            {
              class: "dhx__title"
            },
            `${buttons[this.activeItem].label}`
          ),
          createTable(this.listVal)
        ]
      ),
      handlerInfo(temp),
      createTable(this.beOverdueVal),
      handlerInfo(temp1),
      createTable(this.contactVal)
    ]
  );
};

export default {
  name: "OrderBaseInfo",
  data() {
    return { ...baseData };
  },
  props: ["dataList"],
  watch: {
    // 监听 paramsList 的变化
    dataList: {
      handler(newValue, oldValue) {
        this.dataList = newValue;
        console.log(this.dataList, " this.dataList");
        // this.listVal = convertToKeyValueArray(
        //   this.dataList["product"],
        //   "product"
        // );
        this.listVal = convertToKeyValueArray(this.dataList, "product");
        this.beOverdueVal = convertToKeyValueArray(this.dataList, "beOverdue");
        this.contactVal = convertToKeyValueArray(this.dataList, "contact");
      },
      deep: true,
      immediate: false
    }
  },
  components: { TableTemp },
  methods: { ...funcs },
  render
};
</script>



// WEBPACK FOOTER //
// src/views/collection/manage/orderInfo/index.vue